export default "__VITE_ASSET__BNjXaPgc__"